@if (isDropDownButton()) {
<div ngbDropdown #myDrop="ngbDropdown" [autoClose]="'outside'" (mouseenter)="onHover($event)" (mouseleave)="onHover($event)">
  <button [type]="type()" (click)="myDrop.toggle()" id="dropdownManual" class="nsdc-button" >
    <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
  </button>
  <ul class="naps-dropdown-list dropdown-menu show" *ngIf="myDrop.isOpen()" ngbDropdownMenu
    aria-labelledby="dropdownManual">
    @for (data of dropDownData(); track data) {
    <li class="my-2">
      <a class="dropdown-item" [routerLink]="data.routeLink">
        {{ data.name }}
      </a>
    </li>
    }
  </ul>
</div>
}

@else if(isbuttonWithTag()){
<button class="border-button button-new nsdc-button" [type]="type()" (click)="clicked.emit('')" [routerLink]="tag_Button_Name()?.routeLink">
  {{tag_Button_Name()?.name}}
</button>
}
@else if(isRoutable()){
<button class="border-button nsdc-button" [type]="type()" (click)="clicked.emit('')" [routerLink]="buttonName()?.routeLink">
  <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
</button>
}@else if(isOpenNewTab()){
  <a class="border-button open-new" [role]="type()" [href]="buttonName()?.routeLink" target="_blank" >
    <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
  </a>
  }
@else if(isFilledButton()){
<button class="nsdc-button button button-new" [disabled]="isDisabledButton()" [type]="type()" (click)="clicked.emit('')">
  <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
</button>
}
@else if(isNoFilledButton()){
  <button class="border-button open-new" [type]="type()" (click)="clicked.emit('')">
    <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
  </button>
  }
  @else if(isSecondaryOutLined()){
    <button class="naps-secondary-outlined-btn" [type]="type()" (click)="clicked.emit('')">
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
  }
  @else if(isSecondaryFilled()){
    <button class="naps-secondary-filled-btn" [type]="type()" [disabled]="isDisabledButton()" (click)="clicked.emit('')">
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
  }
@else {
<button class="border-button button-new nsdc-button" [type]="type()" (click)="clicked.emit('')">
  <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
</button>
}

<ng-template #buttonTemplate>
  <ng-content>
    {{buttonName()?.name}}
  </ng-content>
</ng-template>